var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"JNPF-common-layout-header"},[_c('div',{staticClass:"header-logo"}),_c('div',{staticClass:"header-banner"},[_vm._l((_vm.banner),function(item,index){return [_c('div',{key:index,staticClass:"header-banner-item"},[_c('img',{attrs:{"src":item.src,"alt":""}})])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }